import { forwardRef } from 'react';

import { AvatarPlaceholder, AvatarSize, Avatar } from '@hh.ru/magritte-ui';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';

import { ProfileGender } from 'src/types/profile';

const placeholderByGender: Record<ProfileGender, AvatarPlaceholder | undefined> = {
    [ProfileGender.Male]: 'male',
    [ProfileGender.Female]: 'female',
    [ProfileGender.Unknown]: undefined,
};

interface Props {
    size: AvatarSize;
    Element?: 'div' | 'button';
    onClick?: () => void;
}

const ProfileAvatar = forwardRef<HTMLElement, Props>(({ size, onClick, Element = 'div' }, ref) => {
    const { fullName, userPhoto, gender } = useSelectorNonNullable((state) => state.profile);

    return (
        <Avatar
            // ругается на не корретный реф, не может понять по пропсам что ждать Button или Div, более общий тип HTMLElement не понимает
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ref={ref}
            mode="image"
            image={userPhoto?.preview || ''}
            fallbackMode="placeholder"
            placeholder={placeholderByGender[gender]}
            shapeCircle={false}
            aria-label={fullName}
            size={size}
            onClick={onClick}
            Element={Element}
        />
    );
});

export default ProfileAvatar;
